__turbopack_context__.v({
  "bottomSheet": "ProductCardPowerPlug-module__e-7R8G__bottomSheet",
  "root": "ProductCardPowerPlug-module__e-7R8G__root",
});
